"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var utils_1 = require("@lglp/utils");
var ramda_1 = require("ramda");
var Container_1 = require("../../components/Container");
var common_1 = require("./common");
var ServerPortal = function () {
    return (react_1["default"].createElement(Container_1.Container, { id: "portal-container" }, !utils_1.canUseDOM() && ramda_1.map(function (_a) {
        var children = _a.children;
        return children;
    }, common_1.flushPortals())));
};
exports["default"] = ServerPortal;
//# sourceMappingURL=ServerPortal.js.map